import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { useSettings } from '@/contexts/settings-context';

interface SettingsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SettingsModal({ open, onOpenChange }: SettingsModalProps) {
  const { settings, updateSetting } = useSettings();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Settings</DialogTitle>
          <DialogDescription>Customize your emberdesk experience</DialogDescription>
        </DialogHeader>
        <div className="space-y-6 py-4">
          <div className="space-y-3">
            <Label className="text-base font-semibold">Field Type Display</Label>
            <p className="text-sm text-muted-foreground">
              Choose how field type indicators are displayed in the document viewer
            </p>
            <div className="space-y-2">
              <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-accent transition-colors">
                <input
                  type="radio"
                  name="fieldTypeDisplay"
                  value="badge"
                  checked={settings.fieldTypeDisplay === 'badge'}
                  onChange={() => updateSetting('fieldTypeDisplay', 'badge')}
                  className="w-4 h-4"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium">Badge</span>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    Full colored badge with type name (e.g., "string", "number")
                  </p>
                  <div className="mt-2 flex items-center gap-2">
                    <span className="text-xs px-1.5 py-0.5 rounded bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                      string
                    </span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                      number
                    </span>
                  </div>
                </div>
              </label>
              <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-accent transition-colors">
                <input
                  type="radio"
                  name="fieldTypeDisplay"
                  value="pill"
                  checked={settings.fieldTypeDisplay === 'pill'}
                  onChange={() => updateSetting('fieldTypeDisplay', 'pill')}
                  className="w-4 h-4"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium">Pill</span>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    Round colored pill (hover to see type name)
                  </p>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-blue-500" title="string" />
                    <div className="w-3 h-3 rounded-full bg-green-500" title="number" />
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
